import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { UPDATE_DMX_DEVICE } from './actionTypes';
import { updateDmxDeviceSuccessful, updateDmxDeviceFailed } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* updateDevice({ payload: { device } }) {
  try {
    const response = yield call(dmxAPI.updateDevice, device.token, device.id, device);
    if (response.message) {
      yield put(updateDmxDeviceSuccessful(response.message));
    } else throw response.error;
  } catch (error) {
    yield put(updateDmxDeviceFailed(error));
  }
}

export function* watchUpdateDmxDevice() {
  yield takeEvery(UPDATE_DMX_DEVICE, updateDevice);
}

function* updateDmxDeviceSaga() {
  yield all([fork(watchUpdateDmxDevice)]);
}

export default updateDmxDeviceSaga;
